// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__WLBg8","heading":"styles_heading__D1a8v","left":"styles_left__5Q3gn","reflow":"styles_reflow__wgrzH","sticky":"styles_sticky__q_IoQ"};